import { Drzava } from './drzava';
import { BaseDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseContainerService } from 'yt-ng-framework';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { ControlContainer, NgForm, Validators } from '@angular/forms';
import { fcall } from 'q';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-drzava-update',
  templateUrl: './drzava-update.component.html'
})
export class DrzavaUpdateComponent extends BaseUpdateComponent<Drzava> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'DRZAVA.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(200), 'maxlength', 'DRZAVA.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("ISOAlpha2Code", Validators.maxLength(2), 'maxlength', 'DRZAVA.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("ISOAlpha2Code", Validators.pattern('[A-Z]{2}'), 'pattern', 'DRZAVA.ISOALPHA2CODE.VALIDATION.PATTERN');
    this.addValidatorToFc("ISOAlpha3Code", Validators.maxLength(3), 'maxlength', 'DRZAVA.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("ISOAlpha3Code", Validators.pattern('[A-Z]{3}'), 'pattern', 'DRZAVA.ISOALPHA3CODE.VALIDATION.PATTERN');
    // this.addValidatorToFc("ISONumericCode", Validators.pattern('/^(0|[1-9]\d*)$/'), 'pattern', 'DRZAVA.ISONUMERICCODE.VALIDATION.PATTERN');

    // this.addValidatorToFc("Naziv", Validators.pattern('[a-zA-z]+'), 'pattern', 'DRZAVA.NAZIV.VALIDATION.PATTERN');

    //this.errorMessages = {
      //'Naziv': [
        //{ type: 'required', message: 'NAME.REQUIRED' },
        //{ type: 'maxlength', message: 'NAME.MAXLENGTH' }
      //]
    //}
  }

  

}
